import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=b3ff6f68&scoped=true"
import script from "./UploadButton.vue?vue&type=script&lang=js"
export * from "./UploadButton.vue?vue&type=script&lang=js"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=b3ff6f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ff6f68",
  null
  
)

export default component.exports